export default {
  'buyCrypto_title': 'Buy Crypto by Card',
  'buyCrypto_desc': 'Visa/Master Card powered by Advcash/Banaxa/Pagsmile',
  'buyCrypto_spend': 'I will spend',
  'buyCrypto_receive': 'I will receive',
  'buyCrypto_choose': 'Choose Payment Channel',
  'buyCrypto_details': 'Payment Details',
  'buyCrypto_provider': 'Service Provider',
  'buyCrypto_amount': 'Amount (inclusive of transaction fees)',
  'buyCrypto_unit_price': 'Unit Price',
  'buyCrypto_get': 'You will get',
  'Disclaimer': 'Disclaimer',
  'buyCrypto_banxa_disclaimer': "You are now leaving the Biconomy website and an external link will be opened in a new browser window. We are not responsible for any of the contents, advertisements, products, services, or other materials on external sites. We will not be liable for any loss or damage caused in connection with the use or reliance on any content or services available on or through any third-party website.Should you have any issue during the use of such websites' services, please contact {link} directly.",
  'accept_and_continue': 'Accept and Continue',

  "minimum_limit": "Minimum limit is {content}",
  "maximum_limit": "Maximum limit is {content}"
}